export interface ISuspension {
  startDate: string,
  endDate: null | string,
  site: null | string,
  jobCommodity: null | string,
  description: string,
}

export interface ISuspensionsData {
  suspensions: ISuspension[]
}

export const SuspensionsDataAutomation = {
  table: 'suspension-table',
  header: 'suspension-table-header',
  columns: ['suspension-column-headers', 'suspension-column-headers', 'suspension-column-headers', 'suspension-column-headers', 'suspension-column-headers'],
  tBody: 'suspension-tbody'
}